import React from 'react';

function Card({ title, description, imageUrl, language1, language2, language3, githubLink }) {
  return (
    <div className="rounded-lg shadow-md p-4 border-2 text-indigo-600 border-indigo-600 backdrop-blur-lg bg-white/30">
      <img className="w-24 h-24 mx-auto mb-4" src={imageUrl} alt={title} />
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-xl font-semibold text-indigo-600">{title}</h3>
        {githubLink && (
          <a
            href={githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-3 py-1 bg-indigo-600 text-white text-sm rounded-md hover:bg-indigo-700"
          >
            GitHub
          </a>
        )}
      </div>
      <p>{description}</p>
      <div className="flex justify-center">
        <img className="w-12 h-12 mx-1 mb-3" src={language1} alt={title} />
        <img className="w-12 h-12 mx-1 mb-3" src={language2} alt={title} />
        <img className="w-12 h-12 mx-1 mb-3" src={language3} alt={title} />
      </div>
    </div>
  );
}

export default Card;
